//#region IMPORTS
import {
  instoreOrderTypesSelectors,
  fetchInstoreOrderTypesAsync,
} from "../../features/instoreOrderTypes/instoreOrderTypesSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { InstoreOrderType } from "../../models/instoreOrderType";
import { openModal } from "../../features/dashBoard/dashboardSlice";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import useActiveWeekInstoreTemplate from "../../hooks/useActiveWeekInstoreTemplate";
//#endregion

//#region INTERFACE
interface Props {
  closeHandler: () => void;
}
//#endregion

export default function PickInstoreOrderTypeForm({ closeHandler }: Props) {
  //#region SETUP
  const dispatch = useAppDispatch();
  const history = useHistory();
  const types = useAppSelector(instoreOrderTypesSelectors.selectAll);
  const { instoreOrderTypes_Loaded, loading } = useAppSelector(
    (state) => state.instoreOrderTypes,
  );
  const activeWeekTemplate = useActiveWeekInstoreTemplate();
  //#endregion

  //#region LOGIC
  useEffect(() => {
    if (!instoreOrderTypes_Loaded) {
      dispatch(fetchInstoreOrderTypesAsync());
    }
  }, [instoreOrderTypes_Loaded, dispatch]);

  const handlePick = (type: InstoreOrderType) => {
    if (type.name === "Week") {
      if (!activeWeekTemplate) {
        toast.error("No active week template available right now.");
        return;
      }
      dispatch(openModal(false));
      history.push(`/promos/instore/${activeWeekTemplate.id}`);
      return;
    }
    dispatch(openModal(false));
    history.push(`/instoreorders/create?order_type_instore_id=${type.id}`);
  };
  //#endregion

  //#region RENDER
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900">
        Pick an order type
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        Choose which kind of instore order you want to create.
      </p>

      <ul className="mt-4 divide-y divide-gray-100">
        {types.length === 0 && !loading && (
          <li className="py-3 text-sm text-gray-500">
            No order types available.
          </li>
        )}
        {types.map((type) => {
          const weekUnavailable =
            type.name === "Week" && !activeWeekTemplate;
          return (
            <li key={type.id}>
              <button
                type="button"
                onClick={() => handlePick(type)}
                disabled={weekUnavailable}
                className="w-full flex items-center justify-between py-3 px-2 text-left text-gray-900 hover:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:bg-transparent"
              >
                <span>{type.name}</span>
                {weekUnavailable && (
                  <span className="text-xs text-gray-400">
                    no active template
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={closeHandler}
          className="rounded-md bg-white px-3 py-1.5 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          Cancel
        </button>
      </div>
    </div>
  );
  //#endregion
}
